// extracted by mini-css-extract-plugin
export default {"session-panel":"O1GdNN9QzTma1W0AxxXW"};